export default "__VITE_ASSET__DK$jC5VY__"